/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';
import { IDataCategory } from 'app/shared/model/data-category.model';

export interface IIntegrationChannel {
  id?: string;
  name?: string | null;
  code?: string | null;
  description?: string | null;
  cVersion?: string | null;
  active?: boolean | null;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  channelType?: IClinicalDictionary | null;
  categories?: IDataCategory[] | null;
}

export const defaultValue: Readonly<IIntegrationChannel> = {
  active: false,
};
